var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7c0,2.97-2.16,5.43-5,5.91v11.09h-2V12.91c-2.84-.48-5-2.94-5-5.91,0-3.31,2.69-6,6-6s6,2.69,6,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/1762842647/media/icon-pin.1456ce4daf37280d77e603b8c2309f13.svg";
export { ForwardRef as ReactComponent };